import {defineStore} from 'pinia'
import axios from "axios";
import {Loading} from "@/store/Loading";

export const TestStore = defineStore('TestStore', {
    state: () => ({
        firstname: null,
        lastname: null,
        gender: 'Erkek',
        birthDate: null,
        birthTime: null,
        birthCity: 'İstanbul',
        relationship: 'Sevgilim',
        children: null,
        employment: 'Boşta',
        job: null,
        steps: {
            "step1": false,
            "step2": false,
            "step3": false,
            "step4": false,
            "step5": false,
            "step6": false,
        },
        msisdn: null
    }),

    actions: {
        async saveStep(stepName = null) {
            if (stepName) {
                this.steps[stepName] = true;
            }
        },

        async get() {
//            const profile = JSON.parse(localStorage.getItem('__profile'));
//            if (profile) {
//                for (const state in this.$state) {
//                    if (typeof this[state] !== 'undefined') {
//                        this[state] = profile[state];
//                    }
//                }
//            }
//            return this;
        },

        async delete() {
            this.$reset();
        },

        async checkCompletedSteps(step, to, from, next) {
            for (let i = 1; i < step; i++) {
//                console.log('step' + i, this.steps['step' + i]);

                if (!this.steps['step' + i]) {
                    next('/test/test-step-1');
                    return;
                }
            }

            next();
        }

    }
});
